const config = {
  "apigateway_key": "Y3p2SDN2NGNVZ1BDc2xySDdVaWI3T3A4Zw==",
  "version": "1.0.202211180840",
  "application_name": "RSAWeb",
  "serverUrl": "https://rsaweb.gms.telcotech.co",
  "menuExclusionsList": [
    "/authentication/login"
    , "/authentication/reset-password"
  ],
  "authentication": {
    "defaultUserRegistrationGroup": "1"
  },
  "refresh_interval": 30000
}

export { config }
//http://13.245.156.220:8082
//"serverUrl": "http://13.245.156.220:8094",